import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetGMUStoreDevicesRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string | null;
  filters?: Array<{
    field: string;
    values: string[];
    valueType: number;
    operationType: number;
  }>;
  [key: string]: string | number | boolean | undefined | null | Array<any>;
};

export type IGMUStoreDevice = {
  id: number;
  userId: number;
  storeId: number;
  gmuDeviceId: string;
  deviceSerialNumber: string;
  brand: string;
  model: string;
  certificationType: number;
  isActiveOnGMU: boolean;
};

export type GetGMUStoreDevicesResponse = BasePagingResponse<Array<IGMUStoreDevice>>;

export type UpdateGMUStoreDeviceRequest = {
  gMUDeviceId: string;
  isActiveOnGMU: boolean;
};

export type UpdateGMUStoreDeviceResponse = {
  isSuccess: boolean;
  message: string;
  errorCode?: string;
  requestId?: string;
};

async function getGMUStoreDevices(
  data: GetGMUStoreDevicesRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/GMUIntegration/GetGMUStoreDevices", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

async function updateGMUStoreDevice(
  data: UpdateGMUStoreDeviceRequest
): Promise<UpdateGMUStoreDeviceResponse> {
  try {
    return (await axiosInstance.put("/GMUIntegration/UpdateGMUStoreDeviceIsActive", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetGMUStoreDevices() {
  return useMutation<GetGMUStoreDevicesResponse, Error, GetGMUStoreDevicesRequest>(
    (variables) => getGMUStoreDevices(variables)
  );
}

export function useUpdateGMUStoreDevice() {
  return useMutation<UpdateGMUStoreDeviceResponse, Error, UpdateGMUStoreDeviceRequest>(
    (variables) => updateGMUStoreDevice(variables)
  );
}